<template>
  <v-card elevation="0" class="mx-auto">
    <h2 class="pa-4 font-weight-medium">Otras características</h2>
    <v-container>
      <v-row dense class="componente d-none d-sm-flex">
        <v-col
          cols="6"
          class="pa-0"
          v-for="(items, i) in productoCaracteristicas2"
          :key="i"
        >
          <v-row dense>
            <v-col cols="5">
              <v-tooltip v-if="showTooltip(items.name)" max-width="300" top>
                <template v-slot:activator="{ on }">
                  <v-card
                    dense
                    height="18px"
                    class="pa-2 rounded-0"
                    elevation="0"
                    v-on="on"
                  >
                    <div>
                      <p class="text-subtitle-2">
                        {{ itemsName(items.name) }} :
                      </p>
                    </div>
                  </v-card>
                </template>

                <span>{{ items.name }}</span>
              </v-tooltip>

              <v-card
                dense
                height="18px"
                class="pa-2 rounded-0"
                elevation="0"
                v-if="!showTooltip(items.name)"
              >
                <div>
                  <p class="text-subtitle-2">{{ itemsName(items.name) }} :</p>
                </div>
              </v-card>
            </v-col>

            <v-col cols="7">
              <v-tooltip v-if="showTooltip(items.value)" max-width="300" top>
                <template v-slot:activator="{ on }">
                  <v-card
                    dense
                    height="18px"
                    class="pa-1 rounded-0"
                    elevation="0"
                    v-on="on"
                  >
                    <div>
                      <p>{{ itemsDescrip(items.value) }}</p>
                    </div>
                  </v-card>
                </template>

                <span>{{ items.value }}</span>
              </v-tooltip>

              <v-card
                dense
                height="18px"
                class="pa-1 rounded-0"
                elevation="0"
                v-if="!showTooltip(items.value)"
              >
                <div>
                  <p>{{ items.value }}</p>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row
        v-for="(items, i) in productoCaracteristicas2"
        :key="i"
        dense
        class="d-flex d-sm-none"
      >
        <v-col cols="5" class="pa-0">
          <v-tooltip v-if="showTooltip(items.name)" max-width="300" top>
            <template v-slot:activator="{ on }">
              <v-card
                color="#EEEEEE"
                height="25px"
                class="pa-2 rounded-0"
                elevation="0"
                v-on="on"
              >
                <div>
                  <p class="text-subtitle-2">{{ itemsName(items.name) }}</p>
                </div>
              </v-card>
            </template>

            <span>{{ items.name }}</span>
          </v-tooltip>

          <v-card
            color="#EEEEEE"
            height="25px"
            class="pa-2 rounded-0"
            elevation="0"
            v-if="!showTooltip(items.name)"
          >
            <div>
              <p class="text-subtitle-2">{{ itemsName(items.name) }}</p>
            </div>
          </v-card>
        </v-col>

        <v-col cols="7" class="pa-0">
          <v-tooltip v-if="showTooltip(items.value)" max-width="300" top>
            <template v-slot:activator="{ on }">
              <v-card
                height="25px"
                color="#F5F5F5"
                class="pa-2 rounded-0"
                elevation="0"
                v-on="on"
              >
                <div>
                  <p>{{ itemsDescrip(items.value) }}</p>
                </div>
              </v-card>
            </template>

            <span>{{ items.value }}</span>
          </v-tooltip>

          <v-card
            height="25px"
            color="#F5F5F5"
            class="pa-2 rounded-0"
            elevation="0"
            v-if="!showTooltip(items.value)"
          >
            <div>
              <p>{{ itemsDescrip(items.value) }}</p>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "child_ProductCharacteristic2",

  components: {},

  data() {
    return {
      info: [{ id: "", name: "", value: "" }],
      title: "",
    };
  },

  props: {
    productoCaracteristicas2: { type: Array },
    sendSnack: { type: Function },
  },

  methods: {
    showTooltip(name) {
      return name.length > 15;
    },

    itemsName: function (name) {
      return name.length > 15 ? `${name.substring(0, 15)}...` : name;
    },

    itemsDescrip: function (name) {
      return name.length > 15 ? `${name.substring(0, 40)}...` : name;
    },
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},
};
</script>

<style>
.row--dense > .col,
.row--dense > [class*="col-"] {
  padding: 4px;
  padding-bottom: 6px;
}

.componente {
  margin-top: -25px;
}

.imagen {
  width: 340px;
  max-height: 250px;
  margin-left: 15px;
  margin-top: 10px;
}

.v-tooltip__content {
  font-size: 10px !important;
  opacity: 1 !important;
}
</style>
